module.exports = __webpack_public_path__ + "static/img/bo_hui.7db5596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/bo_hui.png
// module id = gk6w
// module chunks = 2